import { useTranslation } from 'react-i18next';
import { Alert, Typography } from '@mui/material';

const ENTEL = 'Entel';

export default function CustomDeliveryMessage({ idEcommerce }) {
  const { t } = useTranslation(['description', 'glossary']);

  const CUSTOM_DELIVERY_MESSAGES = {
    [ENTEL]: {
      title: t('important', { ns: 'glossary' }),
      description: t(
        'orders.deliver.modal.custom_delivery_message.entel_message',
        {
          ns: 'description',
        }
      ),
    },
  };

  const message = CUSTOM_DELIVERY_MESSAGES[idEcommerce];

  if (!message) return null;

  return (
    <Alert variant="outlined" color="primary" severity="info" sx={{ mb: 1.5 }}>
      <Typography
        variant="body1"
        color="primary"
        fontWeight="medium"
        textTransform="uppercase"
      >
        {message.title}
      </Typography>
      <Typography variant="body2" color="primary" whiteSpace="pre-line">
        {message.description}
      </Typography>
    </Alert>
  );
}
